import React from 'react';
import { Button, Grid } from '@mui/material';
import { Done as DoneIcon } from '@mui/icons-material';
import './entryFormSteps.css';
import { setStepIndex } from '../../../redux/reducers/entryFormsSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

export default function EntryFormSteps() {

  const { edittingIndex, entries, stepIndex, agreeToAgreementDate } = useAppSelector((state: any) => state.entryForms);
  const dispatch = useAppDispatch();

  const steps = [
    'Step 1. Fill-in Entry form(s)',
    'Step 2. Review',
    'Step 3. Submit Payment',
    'Step 4. Done'
  ]
  const getColor = (myStep: number) => {
    return myStep < stepIndex ? 'green' : 'black'
  }

  const getFontWeight = (myStep: number) => {
    return myStep === stepIndex ? 'bold' : 'normal'
  }

  const handleChangeStep = (e: any, index: number) => {
    dispatch(setStepIndex(index));
  }

  return (
    <Grid container className='noprint'>
      <>
        { steps.map((stepText: string, index: number) => 
          <Grid item md={3} xs={12} p={2} key={'entry-form-step-' + index}>
            <Button 
              id={ `entry-form-step-${index + 1}`}
              style={{ textTransform: 'none', color: getColor(index), fontWeight: getFontWeight(index) }}
              variant="outlined"
              disabled={ (entries.length === 0 && index > 0) || (index === 2 && agreeToAgreementDate === '') || index === 3 || edittingIndex > -1 }
              onClick={(e: any) => handleChangeStep(e, index) }>{ stepText }
            </Button>
            { stepIndex > index || stepIndex === 3 ? 
              <DoneIcon id={ 'entry-form-steps-done-' + (index + 1)} style={{ fontSize: 18 }} />
              : null
            }
          </Grid>
        )}
      </>
    </Grid>
  )
}
